import type { CSSProperties } from 'react';
import { P } from './icons-paths';

export type IconName = keyof typeof P | string;

/** Demo `ic(name, style)` ning React ko'rinishi: 24×24, stroke=currentColor. */
export function Ic({ n, style, className = 'i', size }: { n: IconName; style?: CSSProperties; className?: string; size?: number }) {
  const st: CSSProperties | undefined = size ? { width: size, height: size, ...style } : style;
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" style={st}
      dangerouslySetInnerHTML={{ __html: P[n] ?? '' }} />
  );
}
